@if (!mode) { @switch (template) { @case ('external') {
<a
  [attr.download]="download ? 'download' : null"
  class="-external"
  [href]="to"
  target="_blank"
  rel="noopener noreferrer"
  [attr.disabled]="disabled">
  <ng-container *ngTemplateOutlet="content"></ng-container>
  <icon class="-xsm" icon="external-link"></icon>
</a>
} @case ('newTab') {
<a
  [attr.download]="download ? 'download' : null"
  class="-external"
  [routerLink]="to"
  target="_blank"
  rel="noopener noreferrer"
  [attr.disabled]="disabled">
  <ng-container *ngTemplateOutlet="content"></ng-container>
  <icon class="-xsm" icon="external-link"></icon>
</a>
} @case ('internal') {
@if (target === '_blank') {
<a
  [href]="getFullInternalUrl()"
  target="_blank"
  rel="noopener noreferrer"
  [attr.disabled]="disabled">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</a>
} @if (redirectViaServer && target !== '_blank') {
<a [href]="getFullInternalUrl()" [target]="target || '_self'" [attr.disabled]="disabled" (click)="handleRedirect($event, getFullInternalUrl())">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</a>
} @if (!redirectViaServer && target !== '_blank') {
<a [routerLink]="url" [queryParams]="tree.queryParams" [fragment]="tree.fragment" [attr.disabled]="disabled">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</a>
}
} @case ('falseInternal') {
<a [href]="to">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</a>
} @case ('noRoute') {
<a [class]="display">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</a>
} } } @if (mode && mode === 'requestnow') {
<a [class]="display">
  <ng-container *ngTemplateOutlet="content"></ng-container>
  @if (requestnowProcessing) {
  <icon name="refresh-ccw" class="-refresh -infinite-spin -xsm -colorPrimaryGreen"></icon>
  } @if (requestnowProcessing === false) {
  <icon name="check" class="-refresh -xsm -colorPrimaryGreen"></icon>
  }
</a>
} @if (mode && mode === 'getapikey') {
<a [class]="display">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</a>
}

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
